export const ROOT = "/admin/consumer"
// export const CONSUMER_SCAN_HISTORY = `${ROOT}/:consumerId/scans`
export const CONSUMER_DETAILS = `${ROOT}/:consumerId`